module.exports = __webpack_public_path__ + "static/media/Puffy UI.899c34a0.png";